module.exports = __webpack_public_path__ + "img/scientist9.161f24a8.jpg";